var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"z-index-2"},[_c('div',{staticClass:"px-4 pb-0"}),_c('div',{staticClass:"pt-0"},[_c('div',{staticClass:"chart"},[_c('canvas',{key:_vm.counter,staticClass:"chart-canvas",attrs:{"id":_vm.$attrs.chartId}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }